import { slideUp, slideDown } from './../utility/transition'


let x = 0
const count = () => ++x;


export function expand({ toggle, content, className = 'is-open', onChange }) {

	if (!toggle || !content) return

	let isOpen = false

	content.setAttribute('id', content.id || 'expand' + count())
	toggle.setAttribute('aria-expanded', false)
	toggle.setAttribute('aria-controls', content.id)
	toggle.addEventListener('click', toggleHandler)
	ariaClose()
	content.style.display = 'none'

	function ariaOpen() {
		toggle.setAttribute('aria-expanded', true)
		content.removeAttribute('aria-hidden')
		content.setAttribute('tabindex', '0')
	}

	function ariaClose() {
		toggle.setAttribute('aria-expanded', false)
		content.setAttribute('aria-hidden', true)
		content.setAttribute('tabindex', '-1')
	}

	function open() {
		isOpen = true
		runChanges()
		slideDown(content, el => {
			ariaOpen()
			content.focus()
		})
		toggle.classList.add(className)
		content.classList.add(className)
	}

	function close() {
		isOpen = false
		runChanges()
		slideUp(content, el => {
			ariaClose() 
			toggle.focus()
		})
		toggle.classList.remove(className)
		content.classList.remove(className)
	}

	function toggleState() {
		isOpen ? close() : open()
	}

	function toggleHandler(event) {
		// do default action if a meta/command key is pressed
		if (event.metaKey || event.shiftKey || event.ctrlKey || event.altKey) return
		event.preventDefault()
		toggleState()
	}

	let subscriptions = []
	const runChanges = () => onChange ? onChange(content, isOpen) : null

	return {
		open, 
		close, 
		toggle: toggleState,
		el: content
	}
}


export function expandGroup({ context = document, expandSelector, toggleSelector, contentSelector }) {
	const expands = [...context.querySelectorAll(expandSelector)].map(el => {
		const e = expand({
			toggle: el.querySelector(toggleSelector),
			content: el.querySelector(contentSelector),
			onChange: close
		})
		return e
	}).filter(Boolean)

	function close(el, status) {
		if (status) expands.forEach(x => x.el !== el && x.close())
	}
}